<div class="p-3">
  <div class="row justify-content-center">
    <i class="bi bi-exclamation-circle exclamacion-acceso mt-5"></i>
  </div>
  
  <h1 class="mb-4">Acceso denegado</h1>
  
  <div class="row justify-content-center">
    <p class="text-center texto-descripcion my-5">
      <strong>¡Lo sentimos!</strong> Tu usuario no cuenta con acceso autorizado al Portal de Calificaciones.<br><br>
      <strong>¿Necesitas ayuda?</strong> Nos puedes contactar a través de estas alternativas:<br><br>
      <strong>Si eres docente</strong>: Ingresa una solicitud en <a href="https://ayuda.duoc.cl/hc/es-419/requests/new?ticket_form_id=18415242229133" class="hypervinculo">Ayuda Duoc</a>.<br>
      <strong>Si eres administrativo</strong>: Contacta a tu equipo DARA de sede.
    </p>
  </div>
  
  <div class="row justify-content-center mt-5">
    <button (click)="irAlLogin()" class="btn boton-primario">ACEPTAR</button>
  </div>
</div>